<template>
  <main class="rights">
    <Loader v-if="loader" />
    <div class="rights__table" v-if="!loader">
      <table>
        <thead>
          <tr>
            <td>Name</td>
            <td>Id</td>
            <td>Admin payments</td>
            <td>Fraud info</td>
            <td>Manage User Items</td>
            <td>Moderator Payments</td>
            <td>Read User Items</td>
            <td>Rns</td>
            <td>Super</td>
            <td>Support Payments</td>
            <td>Anti-Scam</td>
            <td>Accounting</td>
            <td>MM2-Beta</td>
            <td>goods_admin</td>
            <td>balances</td>
            <td>reviews</td>
          </tr>
        </thead>
        <tbody>
          <TableRowRights
            v-for="(person, id) in persons"
            :person="person"
            :id="person.user_id"
            :key="person.user_id"
            :requestBody="requestBody.permissions"
          />
        </tbody>
      </table>
      <div class="rights__change">
        <div class="rights__change__wrapperInput">
          <input placeholder="2FA:" v-model="twoFa" />
        </div>
        <button :class="{ disable: !twoFa }" @click="changeRights">Изменить</button>
      </div>
      <p class="errorMsg" v-if="errorMsg">Ошибка</p>
      <p class="success" v-if="success">Успешно</p>
    </div>
  </main>
</template>

<script>
import './rights.scss'

import http from '../../utils/http'
import cookie from 'vue-cookie'
import Loader from '../../components/Loader/Loader'
import TableRowRights from '../../components/TableRowRights/TableRowRights'

export default {
  name: 'Rights',
  components: {
    Loader,
    TableRowRights
  },
  data() {
    return {
      loader: false,
      twoFa: '',
      errorMsg: false,
      success: false,
      persons: [],
      requestBody: {
        permissions: {}
      }
    }
  },
  mounted() {
    this.getAccessRights()
  },
  methods: {
    async getAccessRights() {
      this.loader = true
      const response = await http.get(
        `https://auth.apineural.com/api/user/admin-roles`,
        cookie.get('token')
      )

      if (response.statusCode === 200) {
        this.persons = response.data.admins
      }
      this.loader = false
    },
    async changeRights() {
      this.requestBody.code = this.twoFa
      this.twoFa = ''
      fetch('https://auth.apineural.com/api/user/admin-roles', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookie.get('token')}`
        },
        body: JSON.stringify(this.requestBody)
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.success = true
            this.getAccessRights()
            setTimeout(() => {
              this.success = false
            }, 1500)
          } else {
            this.errorMsg = true
            setTimeout(() => {
              this.errorMsg = false
            }, 1500)
          }
        })
    }
  }
}
</script>
